export type AllergyItem = {
	item: string;
	selected: boolean;
	items: {
		item: string;
		selected: boolean;
	}[];
}

export const arrayAllergies: {
  item: string;
  selected: boolean;
  items: {
      item: string;
      selected: boolean;
  }[];
}[] = [
	{
		item: 'Sem alergia declarada',
		selected: false,
		items: [
			{
				item: 'Afirma desconhecer se possui alergias',
				selected: false

			},
			{
				item: 'Afirma não possuir alergias',
				selected: false

			}
		]
	},
	{
		item: 'Alimentos',
		selected: false,
		items: [
			{
				item: 'Camarão',
				selected: false

			},
			{
				item: 'Frutos do mar',
				selected: false

			},
			{
				item: 'Glúten',
				selected: false

			},
			{
				item: 'Lactose',
				selected: false

			},
			{
				item: 'Outros',
				selected: false

			}
		]
	},
	{
		item: 'Antibióticos',
		selected: false,
		items: [
			{
				item: 'Amoxilina',
				selected: false

			},
			{
				item: 'Ampicilina',
				selected: false

			},
			{
				item: 'Azitromicina',
				selected: false

			},
			{
				item: 'Bactrim',
				selected: false

			},
			{
				item: 'Benzetacil',
				selected: false

			},
			{
				item: 'Cefalexina',
				selected: false

			},
			{
				item: 'Cefalosporina',
				selected: false

			},
			{
				item: 'Ceftriaxona',
				selected: false

			},
			{
				item: 'Ciprofloxacina',
				selected: false

			},
			{
				item: 'Claritromicina',
				selected: false

			},
			{
				item: 'Clavulin',
				selected: false

			},
			{
				item: 'Cloranfenicol',
				selected: false

			},
			{
				item: 'Eritromicina',
				selected: false

			},
			{
				item: 'Floxacin',
				selected: false

			},
			{
				item: 'Levofloxacina',
				selected: false

			},
			{
				item: 'Macrodantina',
				selected: false

			},
			{
				item: 'Metronidazol',
				selected: false

			},
			{
				item: 'Norfloxacin',
				selected: false

			},
			{
				item: 'Penicilina',
				selected: false

			},
			{
				item: 'Piperacillin-Tazobactam',
				selected: false

			},
			{
				item: 'Quemicetina',
				selected: false

			},
			{
				item: 'Rifampicina',
				selected: false

			},
			{
				item: 'Sulfa',
				selected: false

			},
			{
				item: 'Teicoplanin',
				selected: false

			},
			{
				item: 'Tetraciclina',
				selected: false

			},
			{
				item: 'Vancomicina',
				selected: false

			},
			{
				item: 'Vibramicina',
				selected: false

			},
			{
				item: 'Outros',
				selected: false

			}
		]
	},
	{
		item: 'Anticonvulsionantes',
		selected: false,
		items: [
			{
				item: 'Fenitoina',
				selected: false

			},
			{
				item: 'Outros',
				selected: false

			}
		]
	},
	{
		item: 'Antiemético',
		selected: false,
		items: [
			{
				item: 'Metoclopramida',
				selected: false

			},
			{
				item: 'Outros',
				selected: false
			}
		]
	},
	{
		item: 'Anti-inflamatórios',
		selected: false,
		items: [
			{
				item: 'AAS',
				selected: false

			},
			{
				item: 'Ibuprofeno',
				selected: false

			},
			{
				item: 'Diclofenaco',
				selected: false

			},
			{
				item: 'Outros',
				selected: false

			}
		]
	},
	{
		item: 'Botânicos',
		selected: false,
		items: [
			{
				item: 'Pólen',
				selected: false

			},
			{
				item: 'Outros',
				selected: false

			}
		]
	},
	{
		item: 'Contraste',
		selected: false,
		items: [
			{
				item: 'Contraste Iodado',
				selected: false

			},
			{
				item: 'Gadolíneo',
				selected: false

			},
			{
				item: 'Outros',
				selected: false

			}
		]
	},
	{
		item: 'Curativos/Bandagens',
		selected: false,
		items: [
			{
				item: 'Esparadrapo',
				selected: false

			},
			{
				item: 'Micropore',
				selected: false

			},
			{
				item: 'Outros',
				selected: false

			}
		]
	},
	{
		item: 'Opióides',
		selected: false,
		items: [
			{
				item: 'Morfina',
				selected: false

			},
			{
				item: 'Tramadol',
				selected: false

			},
			{
				item: 'Outros',
				selected: false

			}
		]
	},
	{
		item: 'Produtos Químicos',
		selected: false,
		items: [
			{
				item: 'Látex',
				selected: false

			},
			{
				item: 'Outros',
				selected: false

			}
		]
	}
]


// export type Allergyname = {
//   name: string;
//   id: string;
//   selected: boolean;
//   types: {
//     name: string;
//     id: string;
//     selected: boolean;
//   }[];
// }

// export const arrayAllergies: Allergyname[] = [
//   {
//     name: 'Sem alergia declarada',
//     id: 'no-allergy',
//     selected: false,
//     types: [
//       {
//         name: 'Afirma desconhecer se possui alergias',
//         id: 'afirm-unknown',
//         selected: false
//       },
//       {
//         name: 'Afirma não possuir alergias',
//         id: 'afirm-no-allergies',
//         selected: false
//       }
//     ]
//   },
//   {
//     name: 'Alimentos',
//     id: 'food',
//     selected: false,
//     types: [
//       {
//         name: 'Camarão',
//         id: 'shrimp',
//         selected: false
//       },
//       {
//         name: 'Frutos do mar',
//         id: 'seafood',
//         selected: false
//       },
//       {
//         name: 'Glúten',
//         id: 'gluten',
//         selected: false
//       },
//       {
//         name: 'Lactose',
//         id: 'lactose',
//         selected: false
//       },
//       {
//         name: 'Outros',
//         id: 'food-others',
//         selected: false
//       }
//     ]
//   },
//   {
//     name: 'Antibióticos',
//     id: 'antibiotics',
//     selected: false,
//     types: [
//       {
//         name: 'Amoxilina',
//         id: 'amoxicillin',
//         selected: false
//       },
//       {
//         name: 'Ampicilina',
//         id: 'ampicillin',
//         selected: false
//       },
//       {
//         name: 'Azitromicina',
//         id: 'azithromycin',
//         selected: false
//       },
//       {
//         name: 'Bactrim',
//         id: 'bactrim',
//         selected: false
//       },
//       {
//         name: 'Benzetacil',
//         id: 'benzetacil',
//         selected: false
//       },
//       {
//         name: 'Cefalexina',
//         id: 'cephalexin',
//         selected: false
//       },
//       {
//         name: 'Cefalosporina',
//         id: 'cephalosporin',
//         selected: false
//       },
//       {
//         name: 'Ceftriaxona',
//         id: 'ceftriaxone',
//         selected: false
//       },
//       {
//         name: 'Ciprofloxacina',
//         id: 'ciprofloxacin',
//         selected: false
//       },
//       {
//         name: 'Claritromicina',
//         id: 'clarithromycin',
//         selected: false
//       },
//       {
//         name: 'Clavulin',
//         id: 'clavulin',
//         selected: false
//       },
//       {
//         name: 'Cloranfenicol',
//         id: 'chloramphenicol',
//         selected: false
//       },
//       {
//         name: 'Eritromicina',
//         id: 'erythromycin',
//         selected: false
//       },
//       {
//         name: 'Floxacin',
//         id: 'floxacin',
//         selected: false
//       },
//       {
//         name: 'Levofloxacina',
//         id: 'levofloxacin',
//         selected: false
//       },
//       {
//         name: 'Macrodantina',
//         id: 'macrodantine',
//         selected: false
//       },
//       {
//         name: 'Metronidazol',
//         id: 'metronidazole',
//         selected: false
//       },
//       {
//         name: 'Norfloxacin',
//         id: 'norfloxacin',
//         selected: false
//       },
//       {
//         name: 'Penicilina',
//         id: 'penicillin',
//         selected: false
//       },
//       {
//         name: 'Piperacillin-Tazobactam',
//         id: 'piperacillin-tazobactam',
//         selected: false
//       },
//       {
//         name: 'Quemicetina',
//         id: 'chemicetin',
//         selected: false
//       },
//       {
//         name: 'Rifampicina',
//         id: 'rifampicin',
//         selected: false
//       },
//       {
//         name: 'Sulfa',
//         id: 'sulfa',
//         selected: false
//       },
//       {
//         name: 'Teicoplanin',
//         id: 'teicoplanin',
//         selected: false
//       },
//       {
//         name: 'Tetraciclina',
//         id: 'tetracycline',
//         selected: false
//       },
//       {
//         name: 'Vancomicina',
//         id: 'vancomycin',
//         selected: false
//       },
//       {
//         name: 'Vibramicina',
//         id: 'vibramycin',
//         selected: false
//       },
//       {
//         name: 'Outros',
//         id: 'others-antibiotics',
//         selected: false
//       }
//     ]
//   },
//   {
//     name: 'Anticonvulsionantes',
//     id: 'anticonvulsants',
//     selected: false,
//     types: [
//       {
//         name: 'Fenitoina',
//         id: 'phenytoin',
//         selected: false
//       },
//       {
//         name: 'Outros',
//         id: 'others-anticonvulsants',
//         selected: false
//       }
//     ]
//   },
//   {
//     name: 'Antiemético',
//     id: 'antiemetic',
//     selected: false,
//     types: [
//       {
//         name: 'Metoclopramida',
//         id: 'metoclopramide',
//         selected: false
//       },
//       {
//         name: 'Outros',
//         id: 'others-antiemetic',
//         selected: false
//       }
//     ]
//   },
//   {
//     name: 'Anti-inflamatórios',
//     id: 'anti-inflammatories',
//     selected: false,
//     types: [
//       {
//         name: 'AAS',
//         id: 'aas',
//         selected: false
//       },
//       {
//         name: 'Ibuprofeno',
//         id: 'ibuprofen',
//         selected: false
//       },
//       {
//         name: 'Diclofenaco',
//         id: 'diclofenac',
//         selected: false
//       },
//       {
//         name: 'Outros',
//         id: 'others-anti-inflammatories',
//         selected: false
//       }
//     ]
//   },
//   {
//     name: 'Botânicos',
//     id: 'botanicals',
//     selected: false,
//     types: [
//       {
//         name: 'Pólen',
//         id: 'pollen',
//         selected: false
//       },
//       {
//         name: 'Outros',
//         id: 'others-botanicals',
//         selected: false
//       }
//     ]
//   },
//   {
//     name: 'Contraste',
//     id: 'contrast',
//     selected: false,
//     types: [
//       {
//         name: 'Contraste Iodado',
//         id: 'iodized-contrast',
//         selected: false
//       },
//       {
//         name: 'Gadolíneo',
//         id: 'gadolinium',
//         selected: false
//       },
//       {
//         name: 'Outros',
//         id: 'others-contrast',
//         selected: false
//       }
//     ]
//   },
//   {
//     name: 'Curativos/Bandagens',
//     id: 'curative-bandages',
//     selected: false,
//     types: [
//       {
//         name: 'Esparadrapo',
//         id: 'patch',
//         selected: false
//       },
//       {
//         name: 'Micropore',
//         id: 'micropore',
//         selected: false
//       },
//       {
//         name: 'Outros',
//         id: 'others-curative-bandages',
//         selected: false
//       }
//     ]
//   },
//   {
//     name: 'Opióides',
//     id: 'opioids',
//     selected: false,
//     types: [
//       {
//         name: 'Morfina',
//         id: 'morphine',
//         selected: false
//       },
//       {
//         name: 'Tramadol',
//         id: 'tramadol',
//         selected: false
//       },
//       {
//         name: 'Outros',
//         id: 'others-opioids',
//         selected: false
//       }
//     ]
//   },
//   {
//     name: 'Produtos Químicos',
//     id: 'chemicals',
//     selected: false,
//     types: [
//       {
//         name: 'Látex',
//         id: 'latex',
//         selected: false
//       },
//       {
//         name: 'Outros',
//         id: 'others-chemicals',
//         selected: false
//       }
//     ]
//   }
// ]
